export function dateTimeToDateString(dateTime: Date | undefined | null, defaultText?: string): string {
    if (dateTime === undefined || dateTime === null) {
        return defaultText ?? "";
    }
    let date: string;
    date = dateTime.toString().slice(0, 10);
    return date;
}

export function formatDate(date?: Date) {
    var d = date ? new Date(date) : new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export function addToMonth(date: Date | undefined, months: number) {
    var d = new Date(date || new Date());
    d.setMonth(d.getMonth() + (months || 0), d.getDate());
    return d;
}